module.exports = __webpack_public_path__ + "img/load_paint.png";